import { render, staticRenderFns } from "./InductorResults.vue?vue&type=template&id=4a7a672e&scoped=true"
import script from "./InductorResults.vue?vue&type=script&lang=ts"
export * from "./InductorResults.vue?vue&type=script&lang=ts"
import style0 from "./InductorResults.vue?vue&type=style&index=0&id=4a7a672e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a7a672e",
  null
  
)

export default component.exports